import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.36612 5.11612C1.85427 4.62796 2.64573 4.62796 3.13388 5.11612L9 10.9822L12.4021 7.58012C12.8445 7.13776 13.5457 7.09054 14.0434 7.46959C16.3677 9.2399 18.0387 11.7313 18.7947 14.553L20.4675 11.656C20.8127 11.0581 21.5772 10.8533 22.175 11.1985C22.7729 11.5437 22.9777 12.3082 22.6325 12.906L19.4505 18.417C19.2847 18.7041 19.0117 18.9136 18.6915 18.9994C18.3713 19.0852 18.0301 19.0403 17.743 18.8745L12.232 15.6925C11.6341 15.3473 11.4293 14.5828 11.7745 13.985C12.1197 13.3871 12.8842 13.1823 13.482 13.5275L16.3801 15.2008C15.8614 13.2645 14.8112 11.52 13.3582 10.1596L9.88388 13.6339C9.39573 14.122 8.60427 14.122 8.11612 13.6339L1.36612 6.88388C0.877961 6.39573 0.877961 5.60427 1.36612 5.11612Z"
        fill={colorValue}
      />
    </svg>
  );
};
